import React from "react";
import Widthcontainer from "../../components/customcomponents/widthcontainer";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import BlogPostCard from "./BlogPostCard";

function RelatedSection({ data }) {
   return (
      <>
         <div className="d-flex my-4 w-100 justify-center">
            <h2 className="trending_heading">Related Blogs</h2>
         </div>
         <Widthcontainer className={"BlogSlider"}>
            <div className="slider_responsive py-3 px-3 fixed-width75 mt-2 mb-5">
               {" "}
               <Splide
                  options={{
                     type: "loop",
                     hasTrack: false,
                     perPage: 3,
                     autoHeight: true,
                     center: true,
                     breakpoints: {
                        660: {
                           perPage: 1,
                           perMove: 1,
                        },
                        780: {
                           perPage: 2,
                           perMove: 2,
                        },
                        992: {
                           perPage: 2,
                           perMove: 2,
                        },
                        1200: {
                           perPage: 3,
                           perMove: 3,
                        },
                     },
                  }}
               >
                  {Object.entries(data)?.map(([key, value]) => {
                     return (
                        <SplideSlide>
                           <BlogPostCard data={value} />
                        </SplideSlide>
                     );
                  })}
               </Splide>
            </div>
         </Widthcontainer>
      </>
   );
}

export default RelatedSection;
